import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faTable } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const ItemsPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "Overview", "label": "axFormLayout.inventtable.tabs.overview", "order": 1, "groups": [{"groupId": "Overview_MainFields", "label": "axFormLayout.inventtable.groups.overview.overview_mainfields", "order": 1, "fields": ["inventtypeitemid", "inventgramajeitemid", "inventvenditemid", "comitemid", "itemId", "itemname", "namealias", "itemgroupid", "itemtype", "width", "depth", "itemcertificated"]}], "fields": []}, {"tabId": "General", "label": "axFormLayout.inventtable.tabs.general", "order": 2, "groups": [{"groupId": "InventIdentification", "label": "axFormLayout.inventtable.groups.general.inventidentification", "order": 2, "fields": ["genericgramajeitemid"]}, {"groupId": "Groups", "label": "axFormLayout.inventtable.groups.general.groups", "order": 5, "fields": ["modelgroupid", "dimgroupid", "reqgroupid", "batchnumgroupid", "rappelgroupid"]}], "fields": []}, {"tabId": "Setup", "label": "axFormLayout.inventtable.tabs.setup", "order": 3, "groups": [{"groupId": "PriceUpdate", "label": "axFormLayout.inventtable.groups.setup.priceupdate", "order": 1, "fields": ["purchmodel", "costmodel", "salesmodel"]}, {"groupId": "ItemData", "label": "axFormLayout.inventtable.groups.setup.itemdata", "order": 2, "fields": ["unitvolume", "taxpackagingqty", "netweight"]}], "fields": []}, {"tabId": "References", "label": "axFormLayout.inventtable.tabs.references", "order": 4, "groups": [{"groupId": "BOMGroup", "label": "axFormLayout.inventtable.groups.references.bomgroup", "order": 2, "fields": ["bomunitid"]}, {"groupId": "ItemCovGroup", "label": "axFormLayout.inventtable.groups.references.itemcovgroup", "order": 7, "fields": ["primaryvendorid"]}], "fields": []}, {"tabId": "PriceDisc", "label": "axFormLayout.inventtable.tabs.pricedisc", "order": 5, "groups": [{"groupId": "PriceDiscPurch", "label": "axFormLayout.inventtable.groups.pricedisc.pricediscpurch", "order": 1, "fields": ["linedisc"]}], "fields": []}, {"tabId": "Qty", "label": "axFormLayout.inventtable.tabs.qty", "order": 6, "groups": [{"groupId": "QtyColumn1", "label": "axFormLayout.inventtable.groups.qty.qtycolumn1", "order": 1, "fields": ["blocked"]}], "fields": []}, {"tabId": "Various", "label": "axFormLayout.inventtable.tabs.various", "order": 7, "groups": [{"groupId": "ItemAlternative", "label": "axFormLayout.inventtable.groups.various.itemalternative", "order": 2, "fields": ["usealtitemid", "altitemid"]}, {"groupId": "ForeignTrade", "label": "axFormLayout.inventtable.groups.various.foreigntrade", "order": 5, "fields": ["intracode", "origcountryregionid"]}, {"groupId": "Measurement", "label": "axFormLayout.inventtable.groups.various.measurement", "order": 6, "fields": ["height", "density"]}], "fields": []}, {"tabId": "Dimension", "label": "axFormLayout.inventtable.tabs.dimension", "order": 8, "groups": [{"groupId": "DimensionGroup", "label": "axFormLayout.inventtable.groups.dimension.dimensiongroup", "order": 1, "fields": ["dimension"]}], "fields": []}];

  const baseColumns = [
    {
      key: "itemId",
      label: "items.itemId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "itemname",
      label: "items.itemName",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "salesPrice",
      label: "items.salesPrice",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "taxpackagingqty",
      label: "items.taxpackagingqty",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "height",
      label: "items.height",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "width",
      label: "items.width",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "blocked",
      label: "items.blocked",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "taxgroup",
      label: "items.taxgroup",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "linedisc",
      label: "items.linedisc",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxfamiliaventasid",
      label: "items.idaxfamiliaventasid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxtarifa",
      label: "items.idaxtarifa",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "idaxbarcodeid",
      label: "items.idaxbarcodeid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxmarca",
      label: "items.idaxmarca",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxmodeloid",
      label: "items.idaxmodeloid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxfotodefecto",
      label: "items.idaxfotodefecto",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "idaxcatalog",
      label: "items.idaxcatalog",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "modifieddate",
      label: "items.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "dataAreaId",
      label: "items.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "itemgroupid",
      label: "items.itemgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "itemtype",
      label: "items.itemtype",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "ItemType",
      options: [{"value": 0, "label": "Artículo", "labelKey": "axEnums.ItemType.0"}, {"value": 1, "label": "L. MAT", "labelKey": "axEnums.ItemType.1"}, {"value": 2, "label": "Servicio", "labelKey": "axEnums.ItemType.2"}]    },
    {
      key: "purchmodel",
      label: "items.purchmodel",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "NoYes",
      options: [{"value": 0, "label": "No", "labelKey": "axEnums.NoYes.0"}, {"value": 1, "label": "Sí", "labelKey": "axEnums.NoYes.1"}]    },
    {
      key: "salesmodel",
      label: "items.salesmodel",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "SalesPriceModel",
      options: [{"value": 0, "label": "Ninguno", "labelKey": "axEnums.SalesPriceModel.0"}, {"value": 1, "label": "Coeficiente de contribución", "labelKey": "axEnums.SalesPriceModel.1"}, {"value": 2, "label": "Pct. gastos varios", "labelKey": "axEnums.SalesPriceModel.2"}]    },
    {
      key: "delCostgroupid",
      label: "items.delCostgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "reqgroupid",
      label: "items.reqgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "primaryvendorid",
      label: "items.primaryvendorid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "netweight",
      label: "items.netweight",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "depth",
      label: "items.depth",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "unitvolume",
      label: "items.unitvolume",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "bomunitid",
      label: "items.bomunitid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "density",
      label: "items.density",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "dimension",
      label: "items.dimension",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "dimension2",
      label: "items.dimension2",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "dimension3",
      label: "items.dimension3",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "costmodel",
      label: "items.costmodel",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "NoYes",
      options: [{"value": 0, "label": "No", "labelKey": "axEnums.NoYes.0"}, {"value": 1, "label": "Sí", "labelKey": "axEnums.NoYes.1"}]    },
    {
      key: "usealtitemid",
      label: "items.usealtitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "ItemNumAlternative",
      options: [{"value": 0, "label": "Nunca", "labelKey": "axEnums.ItemNumAlternative.0"}, {"value": 1, "label": "Sin existencias", "labelKey": "axEnums.ItemNumAlternative.1"}, {"value": 2, "label": "Siempre", "labelKey": "axEnums.ItemNumAlternative.2"}]    },
    {
      key: "altitemid",
      label: "items.altitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "intracode",
      label: "items.intracode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "origcountryregionid",
      label: "items.origcountryregionid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "namealias",
      label: "items.namealias",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "dimgroupid",
      label: "items.dimgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "modelgroupid",
      label: "items.modelgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "batchnumgroupid",
      label: "items.batchnumgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "comitemid",
      label: "items.comitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "genericgramajeitemid",
      label: "items.genericgramajeitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventgramajeitemid",
      label: "items.inventgramajeitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventtrateonly",
      label: "items.inventtrateonly",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventtypeitemid",
      label: "items.inventtypeitemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventtypeitemidorderby",
      label: "items.inventtypeitemidorderby",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventtypeonly",
      label: "items.inventtypeonly",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "inventvenditemid",
      label: "items.inventvenditemid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "itemcertificated",
      label: "items.itemcertificated",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "NoYes",
      options: [{"value": 0, "label": "No", "labelKey": "axEnums.NoYes.0"}, {"value": 1, "label": "Sí", "labelKey": "axEnums.NoYes.1"}]    },
    {
      key: "rappelgroupid",
      label: "items.rappelgroupid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "recId",
      label: "items.recId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="items"
      permissionPrefix="legacy.items"
      icon={faTable}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default ItemsPageGen;